import React from "react";
import {useDispatch} from "react-redux";
import {setDialogContent} from "../../app/projectSlice";
import settings from "../../Story/settings";
import StoryContent from "../../Story/features/StoryContent";

import "./Menu.css";
import images from "../../Story/images";

const Menu = (props) => {
    const dispatch = useDispatch();

    const onMenuClick = () => {
        dispatch(setDialogContent("mainMenu"));
    };

    return (
        <div className="left-side-menu">
            <div className="side-menu-controls">
                <button className="side-menu-control-btn" onClick={props.onHideButtonClick}>&lt;</button>
            </div>
            <div className="story-name">
                <h1 className="story-name-caption">{settings.project.name}</h1>
                <h4>by <a
                    className="story-author"
                    href="https://www.patreon.com/le_creatore"
                    target="_blank"
                    style={{color: "red", cursor: "pointer", textDecoration: "none"}}
                >Le-Creatore</a></h4>
                <h5 style={{color: "grey"}}>ver. 0.1.2 "beginning"</h5>
            </div>
            <div className="story-buttons"/>
            <div className="story-content"><StoryContent/></div>

            <div className="story-menu">
                <button className="story-menu-button" onClick={onMenuClick}>Menu</button>
            </div>
            <div>
                <a className="story-patreon" href="https://www.patreon.com/le_creatore" target="_blank">
                    <img style={{width: "50px"}} src={images.game.patreon} alt=""/>
                </a><span style={{paddingRight: "20px"}}/>
                <a className="story-buymeacoffee" href="https://www.buymeacoffee.com/lecreatore" target="_blank">
                    <img style={{width: "50px"}} src={images.game.buyMeACoffee} alt=""/>
                </a>
            </div>
        </div>
    )
};

export default Menu;